export default __webpack_public_path__ + "static/7years-368d6bc23a2401493c397ddbe946ee70.svg";